<template>
  <div>
    <div class="tgw-title">
      <div>{{ $t("RAM.AWS.tgw.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:aws:tgw:update']"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:aws:tgw:export']"
          :loading="loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="tgw-top">
      <tencent-gateway-search ref="search"></tencent-gateway-search>
    </div>
    <table-tencent-gateway></table-tencent-gateway>
  </div>
</template>

<script>
import TencentGatewaySearch from "../tgw/TencentGatewaySearch";
import TableTencentGateway from "../tgw/TableTencentGateway";

export default {
  name: "tgw",
  components: {
    TencentGatewaySearch,
    TableTencentGateway
  },
  data() {
    return {
      modal_loading: false,
      loading: false
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;
      this.$api.resourceManagement
        .updateResource({
          resourceManagement: 26,
          accountType: 1
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAwsTgw({
          companyId: this.$refs.search.companyId,
          accountName: this.$refs.search.accountName,
          tgwId: this.$refs.search.tgwId
        })
        .then(res => {
          let fileName = "tgw.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.tgw-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.tgw-title > div:nth-child(1) {
  float: left;
}
.tgw-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.tgw-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/tgw/TGW.vue